import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../rootState'

export const getSidebar = createSelector(
  (state: RootState) => state.sidebar,
  sidebar => sidebar,
)
